<template>
	<div id="app" v-if="!isOAuth">
		<div class="main-container" v-if="visible">
			<component v-bind:is="layout"></component>
		</div>
	</div>
</template>

<script>
import { UPLOAD_USER_LOCALISATION } from 'actions/localization'
import AppLayout from '@/views/layouts/AppLayout'
import AuthLayout from '@/views/layouts/AuthLayout'
import AttachLayout from '@/views/layouts/AttachLayout'

export default {
	name: 'app',
	metaInfo: {
		titleTemplate: '%s | ' + process.env.VUE_APP_TITLE
	},
	computed: {
		layout () {
			if (this.$store.getters.getStatusCompanyLoad) {
				if (this.$store.getters.isAuthenticated && this.$store.getters.getCompanyList.length === 0) {
					window.location.href = process.env.VUE_APP_DOCU_ID_URL + '/companies'
				} else {
					return 'app-layout'
				}
			} else {
				// return 'auth-layout'
			}
		},
		visible () {
			return this.$store.getters.getStatusLoadedCommonLocale
		},
		isOAuth () {
			return this.$store.getters.getOAuthStatus && this.$store.getters.isAuthenticated
		}
	},
	created: function () {
		if (this.$store.getters.isAuthenticated) {
			this.$store.dispatch(UPLOAD_USER_LOCALISATION)
		}
	},
	components: {
		'app-layout': AppLayout,
		'auth-layout': AuthLayout,
		'attach-layout': AttachLayout
	}
}
</script>


<style lang="scss">
	@import "./assets/old_resources/styles/core_styles/reset.css";
	@import "./assets/old_resources/bower_components/bootstrap/dist/css/bootstrap.min.css";
	@import "./assets/old_resources/styles/view/bootstrap-table.css";
	@import "./assets/old_resources/bower_components/sweetalert2/src/sweetalert2";
	@import "~trumbowyg/dist/ui/sass/trumbowyg.scss";
	/*@import "./assets/old_resources/styles/view/sweet-alert.css";*/
	@import "./assets/old_resources/bower_components/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css";
	/*@import "./assets/old_resources/bower_components/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker-standalone.css";*/
	/*@import "./assets/old_resources/bower_components/bootstrap-datepicker/css/datepicker3.css";*/
	@import "./assets/old_resources/bower_components/fontawesome/css/font-awesome.min.css";
	@import "./assets/old_resources/components/core_components/error/error";
	@import "./assets/old_resources/components/core_components/footer/footer";
	@import "./assets/old_resources/components/core_components/form/form";
	@import "./assets/old_resources/components/core_components/header/header";
	@import "./assets/old_resources/components/core_components/login/login";
	@import "./assets/old_resources/components/core_components/page/page";
	@import "./assets/old_resources/components/input_controls/button/button";
	@import "./assets/old_resources/components/input_controls/checkbox/checkbox";
	@import "./assets/old_resources/components/input_controls/datepicker/datepicker";
	@import "./assets/old_resources/components/input_controls/fileUploader/fileUploader";
	@import "./assets/old_resources/components/input_controls/multicheckbox/multicheckbox";
	@import "./assets/old_resources/components/input_controls/select/select";
	@import "./assets/old_resources/components/input_controls/sleditor/sleditor";
	@import "./assets/old_resources/components/input_controls/textarea/textarea";
	@import "./assets/old_resources/components/input_controls/textInput/textInput";
	@import "./assets/old_resources/components/input_controls/validationError/validationError";
	@import "./assets/old_resources/components/support_gui_components/dragAndDrop/dragAndDrop";
	@import "./assets/old_resources/components/support_gui_components/dropdown/dropdown";
	@import "./assets/old_resources/components/support_gui_components/prevValuesDictionary/prevValuesDictionary";
	@import "./assets/old_resources/components/support_gui_components/sidebar/sidebar";
	@import "./assets/old_resources/components/support_gui_components/spoiler/spoiler";
	@import "./assets/old_resources/components/support_gui_components/table/table";
	@import "./assets/old_resources/components/support_gui_components/table/table_search";
	@import "./assets/old_resources/components/support_gui_components/table/table_toolbar";
	/*@import "./assets/old_resources/components/masterway_components";*/
	@import "./assets/old_resources/components/uikit";
	@import "./assets/old_resources/styles/core_styles/shared_variables";
	/*@import "./assets/old_resources/styles/fix_styles/firefox_fix.css";*/
	/*@import "./assets/old_resources/styles/fix_styles/ie_fix.css";*/
	/*@import "./assets/old_resources/styles/view/bootstrap-table.css";*/
	/*@import "./assets/old_resources/styles/view/sweet-alert.css";*/
	@import "./assets/old_resources/styles/view/bootstrap-treeview.css";
	@import "./assets/old_resources/styles/shared.css";
	@import "./assets/old_resources/styles/core_styles/mediaStyles.css";

	.ace_editor, .ace_editor * { font-family: "Monaco", "Menlo", "Ubuntu Mono", "Droid Sans Mono", "Consolas", monospace !important; font-size: 12px !important; font-weight: 400 !important; letter-spacing: 0 !important; }

	.cle .input,
	.cle .results .expr,
	.cle .results .res {
		font-size: 12px;
		color: #363636;
	}

	.cle {
		position: relative;
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 3px;
		border-radius: 2px;
		border: 2px solid #cccccc;
		box-sizing: border-box;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
	}

	.cle .top-panel {
		width: 100%;
		height: 100%;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		margin: 0 0 -30px 0;
		padding: 0 0 30px 0;
	}

	.cle .bottom-panel {
		position: relative;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 100%;
		height: 30px;
	}

	.cle .results {
		width: 100%;
		height: 100%;
		position: relative;
		padding: 4px;
		background-color: white;
		line-height: 1.5;

		p {
			font-weight: 600;
			position: relative;
			width: max-content;
			top: -18px;
			background-color: #fff;
			padding: 0 5px;
			margin: 0;
		}
	}

	.cle .results .expr {
		padding: 0;
		margin: 0;
	}

	.cle .results .res {
		padding: 0;
		margin: 0 0 5px 30px;
		color: #dc3912;
	}

	.cle .results .expr,
	.cle .results .res {
		background: none;
		border: none;
		/* https://css-tricks.com/snippets/css/make-pre-text-wrap/ */
		white-space: pre-wrap; /* css-3 */
		white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
		white-space: -pre-wrap; /* Opera 4-6 */
		white-space: -o-pre-wrap; /* Opera 7 */
		word-wrap: break-word; /* Internet Explorer 5.5+ */
	}

	.cle .input-left {
		width: 100%;
		height: 100%;
		margin: 0 -80px 0 0;
		padding: 0 80px 4px 0;
		float: left;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.cle .input-right {
		width: 80px;
		height: 100%;
		margin: 0;
		padding: 0 0 4px 4px;
		float: right;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.cle .input {
		width: 100%;
		height: 100%;
		margin: 4px 0 0 0;
		padding: 2px 4px;
		-moz-box-sizing: border-box;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		outline: none;
		border: 1px solid #cccccc;
		background-color: white;
	}

	.cle button.eval {
		color: #363636;
		width: 100%;
		height: 100%;
		margin: 4px 0;
		padding: 0;
		background-color: white;
		border: 1px solid #cccccc;
		&:hover {
			color: $neutral-color;
		}
	}

	.result-info-icon {
		color: white;
		background: lightgray;
		border-radius: 3px;
		display: inline-block;
		text-align: center;
		margin: 0 6px;
		padding: 0 3px;
		cursor: pointer;
		transition: 0.1s all;
	}

	.result-info-icon:hover {
		background: darkgray;
		transition: 0.3s all;
	}

	.swal2-actions {
		z-index: auto;
	}

	.alert-left-aligned {
		text-align: left;
		p {
			margin: 5px 0;
			font-size: 18px;
			span {
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
</style>
